import React, { useRef } from 'react';
import moment from 'moment';

import { InlineInput } from '../../../../Common/DesignSystem/InlineInput';
import { DropdownItem } from '../../../../Common/DesignSystem/Input';
import FileUploadCard from '../../../../Common/DesignSystem/FileUploadCard';

export const VehicleInformation = ({ vehicleForm, inventoryForm, updateVehicleForm, updateSelect, imageThumbnail, imageName, uploadImage, loadingImage, isConvertingToVehicle }) => {
  const fileInputRef = useRef();
  const fileDropRef = useRef();

  // const isLinked = inventoryForm.metadata?.createdBy === 'system';
  // const shouldShowInput = (fieldValue) => !isLinked || (isLinked && !fieldValue)

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '24px' }}>
      <div style={{ display: 'flex', flex: 3, flexDirection: 'column', gap: '8px' }}>
        <label>Vehicle Image</label>
        <FileUploadCard
          imageSrc={imageThumbnail ? imageThumbnail : inventoryForm.photoUrl || null}
          imageName={imageThumbnail ? imageName : ''}
          accept="image/png, image/jpeg"
          uploadText="Add File or Drop File Here"
          inputRef={fileInputRef}
          dropRef={fileDropRef}
          replaceClick={() => fileInputRef.current.click()}
          handleUpload={uploadImage}
          loading={loadingImage}
        />

        <InlineInput label="LICENCE PLATE" name="plate" value={vehicleForm.plate} onChange={updateVehicleForm} />
        <InlineInput label="UNIQUE TAG" name="tag" value={vehicleForm.tag} onChange={updateVehicleForm} />
      </div>

      <div style={{ display: 'flex', flex: 5, flexDirection: 'column', gap: '8px' }}>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
          <InlineInput label="Year" inputFlex={2} name="year" dropdown required value={vehicleForm.year} onChange={(e)=> {updateSelect({name: 'year', value: e.currentTarget.dataset.id})}}>
            {Array.from(new Array(10), (val, index)=> index).map((index) => (
              <DropdownItem label={moment().add(2, 'years').format("YYYY") - index} value={moment().add(2, 'years').format("YYYY") - index}/>
            ))}
          </InlineInput>

          <InlineInput label="MAKE" name="make" required value={vehicleForm.make} onChange={updateVehicleForm} inputFlex={2} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
          <InlineInput label="MODEL" name="model" required value={vehicleForm.model} onChange={updateVehicleForm} inputFlex={2} />
          <InlineInput label="TRIM" name="trim" value={vehicleForm.trim} onChange={updateVehicleForm} inputFlex={2} />
        </div>

        <div style={{ display: 'flex', flex: 1, width: '80%', flexDirection: 'column', gap: '8px' }}>
          <InlineInput label="VIN NUMBER" name="vin" required={isConvertingToVehicle} value={vehicleForm.vin} onChange={updateVehicleForm} containerStyle={{ margin: '8px 0 24px' }} />
          <InlineInput label="MILEAGE" iconName="Mileage" name="km" value={vehicleForm.km} onChange={updateVehicleForm} trailing_ic="KM" trailing_ic_rawText />
          <InlineInput label="EXTERIOR COLOUR" iconName="BodyType" name="exterior_exact_color" value={vehicleForm.exterior_exact_color} onChange={updateVehicleForm} />
          <InlineInput label="INTERIOR COLOUR" iconName="Interior" name="interior_exact_color" value={vehicleForm.interior_exact_color} onChange={updateVehicleForm} />
        </div>
      </div>
    </div>
  );
};
